import { render, staticRenderFns } from "./CartHeader.vue?vue&type=template&id=d65aa620"
import script from "./CartHeader.vue?vue&type=script&lang=js"
export * from "./CartHeader.vue?vue&type=script&lang=js"
import style0 from "./CartHeader.vue?vue&type=style&index=0&id=d65aa620&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports